import { css } from 'emotion';

export const alignFlyoutStyle = (alignFlyout: string) =>
  css`
    align-self: ${alignFlyout === 'top' ? 'flex-start' : 'flex-end'};
  `;

export const dropdownMenuButtonStyle = css`
  width: 100%;
  margin: 0;
  padding: 0;
`;
